export default __webpack_public_path__ + "static/media/animation-arrow3.096b2c4e.gif";